export function isFunction(x: any): x is Function {
  return typeof x === 'function';
}



// WEBPACK FOOTER //
// ./~/rxjs/src/util/isFunction.ts